import { Component } from '@angular/core';
import { LoadingController, NavParams, Platform, AlertController } from 'ionic-angular';
import { ConfigurationManager } from '../../../provider/ConfigurationManager';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { TempTokenService } from '../../../provider/temptokenservice';
import { LatLng, Spherical } from '@ionic-native/google-maps';
import { Network } from '@ionic-native/network';
import * as Constants from '../../../provider/Constants';

@Component({
  selector: 'redeem-page',
  templateUrl: 'redeem.html',

})

export class Redeem {
  QA_END_POINT_URL = 'https://autoclubsouth.qa2.acg.aaa.com/Partners/CCM.aspx?';
  PROD_END_POINT_URL = 'https://autoclubsouth.aaa.com/Partners/CCM.aspx?';
  dealDetail: any;
  headerTitle = 'Redeem Offer';
  shouldShowCard = true;
  nearStoreAddressText = '14539 Military Tri\nDelray Beach, FL\n33484';
  nearStoreDistanceText = '';
  formattedRedemptionLink = '';
  loading;

  constructor(
    public navParams: NavParams,
    private config: ConfigurationManager,
    public viewCtrl: ViewController,
    public tempTokenService: TempTokenService,
    private platform: Platform,
    private network: Network,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController) {

    this.dealDetail = navParams.get('dealModel');
    this.headerTitle = (this.dealDetail.DealTypeID === 3) ? 'Book Now' : 'Redeem Offer';
    this.shouldShowCard = (this.dealDetail.RedemptionLocation === 'Storefront') ? true : false;
    if (this.dealDetail.RedemptionLink) {
      const isNetConnected = this.checkDeviceNetworkConnection();
      if (!isNetConnected) {
        this.showNetworkAlert();
        return;
      }
      this.showLoading();
      this.formatRedemptionLinkURL();
    }
    this.arrangeDealLocation();
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({

    });
    this.loading.present();
  }

  hideLoadingScreen() {
    if (this.loading != null) {
      this.loading.dismiss();
    }
  }


  arrangeDealLocation() {
    if (this.dealDetail.DealLocations.length) {
      this.nearStoreDistanceText = this.getNearestParnterLocation();
      this.nearStoreAddressText = this.dealDetail.DealLocations[0].Address +
        this.dealDetail.DealLocations[0].City + ', ' + this.dealDetail.DealLocations[0].State + this.dealDetail.DealLocations[0].Zip;
    }
  }

  getNearestParnterLocation(): string {
    if (this.dealDetail.DealLocations != null && this.dealDetail.DealLocations[0] != null) {
      const lat = this.dealDetail.DealLocations[0].PartnerLatitude;
      const lng = this.dealDetail.DealLocations[0].PartnerLongitude;
      const lt = new LatLng(lat, lng);
      const lt2 = new LatLng(this.navParams.get('Latitude'), this.navParams.get('Longitude'));
      // let lt2 = new LatLng(0, 0);
      const distanceinmiles: number = Spherical.computeDistanceBetween(lt2, lt) / 1609.344;
      if (distanceinmiles < 10) {
        return distanceinmiles.toFixed(1) + ' mi';
      }
      return distanceinmiles.toFixed(0) + ' mi';
    }
    return '';
  }

  formatRedemptionLinkURL() {
    if (this.dealDetail.RedemptionLink) {
      const link: string = this.dealDetail.RedemptionLink;
      const redemptionLink: string = (link.includes('http') || link.includes('https')) ? link : 'http://' + link;
      const encodedUrl: string = encodeURI(redemptionLink);
      const indexOfDotCom: number = encodedUrl.indexOf('.com');
      const indexOfAAA: number = encodedUrl.indexOf('aaa');
      if ((encodedUrl.includes('aaa') || encodedUrl.includes('AAA')) && !encodedUrl.includes('mages.savings.acg.aaa.com')
        && indexOfAAA !== -1 && indexOfDotCom !== -1) {
        const minusDomain: string = encodedUrl.substring(indexOfDotCom + 4);
        const env = this.navParams.get('environmentConfig');
        const endPoint = (env === 'DEV') ? this.QA_END_POINT_URL : this.PROD_END_POINT_URL;
        const zip: string = 'zip=' + this.config.getZipCode;
        let nextPageUrl = '';
        // tslint:disable-next-line:prefer-conditional-expression
        if ((encodedUrl.includes('aaa') || encodedUrl.includes('AAA'))
          && !encodedUrl.includes('www') && !encodedUrl.includes('ww1')) {
          nextPageUrl = '&nextPage=' + minusDomain;
        } else {
          nextPageUrl = '&nextPage=' + encodedUrl;
        }
        const postParams = {};
        this.tempTokenService.getTemparoryToken(postParams).then(data => {
          const json = JSON.parse(data.data);
          const tempToken: string = '&t=' + json.Token;
          const redeemOfferUrl: string = '' + endPoint + zip + tempToken + nextPageUrl;
          this.formattedRedemptionLink = redeemOfferUrl;
          // window.open(redeemOfferUrl, '_system', 'location=yes');
          this.hideLoadingScreen();
        })
          .catch(error => {
            this.hideLoadingScreen();
            console.log('Error occured');
          });
      }
    }
  }

  dismiss() {
    const data = {};
    this.viewCtrl.dismiss(data).catch(() => {// EMPTY
    });
  }

  checkDeviceNetworkConnection():boolean {
    if (this.platform.is('cordova')) {
      const isNetworkAvailable = (this.network.type === 'none') ? false : true;
      return isNetworkAvailable;
    }
  }

  showNetworkAlert() {
    let alert = this.alertCtrl.create({
      title: Constants.internetAlertTitle,
      subTitle: Constants.internetAlertMessage,
      buttons: [Constants.alertPositiveButtonTitle]
    });
    alert.present();
  }

}
